module.exports = __webpack_public_path__ + "img/facturas-sometidas.202c2772.svg";